export const HUDL_TRACKERS = {
    showcase: {
        namespace: {
            web: 'hudl_showcase_web',
            mobile: 'hudl_showcase_mobile',
            ott: 'hudl_showcase_ott'
        },
        appID: {
            web: 'ShowcaseWeb',
            mobile: 'ShowcaseMobile',
            ott: 'ShowcaseOTT'
        }
    },
    calendar: {
        namespace: {
            web: 'hudl_calendar_web',
            mobile: 'hudl_calendar_mobile',
            ott: undefined
        },
        appID: {
            web: 'CalendarWeb',
            mobile: 'CalendarMobile',
            ott: undefined
        }
    },
    fanx: {
        namespace: {
            web: 'hudl_fanx_web',
            mobile: 'hudl_fanx_mobile',
            ott: 'hudl_fanx_ott'
        },
        appID: {
            web: 'FanXWeb',
            mobile: 'FanXMobile',
            ott: 'FanXOTT'
        }
    },
    'join-team': {
        namespace: {
            web: 'hudl_join_team_web',
            mobile: 'hudl_join_team_mobile',
            ott: undefined
        },
        appID: {
            web: 'JoinTeamWeb',
            mobile: 'JoinTeamMobile',
            ott: undefined
        }
    },
    'performance-core': {
        // Note: The reason the performance core naming isn't consistent with the other trackers
        // is because these names were utilised in production before the shared analytics
        // package was created. DO NOT copy this convention for new trackers.
        namespace: {
            web: 'PerformanceCoreTracker',
            mobile: 'performance_core_mobile',
            ott: undefined
        },
        appID: {
            web: 'PerformanceCore',
            mobile: 'PerformanceCoreMobile',
            ott: undefined
        }
    },
    'performance-core-playlists': {
        // Note: The reason the naming isn't consistent with the other trackers
        // is because these names were utilised in production before the shared analytics
        // package was created. DO NOT copy this convention for new trackers.
        namespace: {
            web: 'PlaylistsSnowplowTracker',
            mobile: undefined,
            ott: undefined
        },
        appID: {
            web: 'PlaylistsSnowplowTracker',
            mobile: undefined,
            ott: undefined
        }
    },
    'performance-core-insights': {
        // Note: The reason the naming isn't consistent with the other trackers
        // is because these names were utilised in production before the shared analytics
        // package was created. DO NOT copy this convention for new trackers.
        namespace: {
            web: 'InsightsModuleSnowplowTracker',
            mobile: undefined,
            ott: undefined
        },
        appID: {
            web: 'InsightsModuleSnowplowTracker',
            mobile: undefined,
            ott: undefined
        }
    },
    messaging: {
        namespace: {
            web: 'hudl_messaging_web',
            mobile: 'hudl_messaging_mobile',
            ott: undefined
        },
        appID: {
            web: 'Messaging',
            mobile: 'MessagingMobile',
            ott: undefined
        }
    },
    videoTracker: {
        // Note: The reason videoTracker naming isn't consistent with the other trackers
        // is because these names were utilised in production before the shared analytics
        // package was created. DO NOT copy this convention for new trackers.
        namespace: {
            web: 'hudlVideoActivityTracker',
            mobile: undefined,
            ott: undefined
        },
        appID: {
            web: 'hudl',
            mobile: undefined,
            ott: undefined
        }
    },
    schedules: {
        namespace: {
            web: 'hudl_schedules_web',
            mobile: 'hudl_schedules_mobile',
            ott: undefined
        },
        appID: {
            web: 'HudlSchedules',
            mobile: 'HudlSchedulesMobile',
            ott: undefined
        }
    },
    parachute: {
        namespace: {
            web: 'hudl_parachute_web',
            mobile: 'hudl_parachute_mobile',
            ott: undefined
        },
        appID: {
            web: 'HudlParachute',
            mobile: 'HudlParachuteMobile',
            ott: undefined
        }
    },
    statsbomb: {
        namespace: {
            web: 'hudl_statsbomb_web',
            mobile: 'hudl_statsbomb_mobile',
            ott: undefined
        },
        appID: {
            web: 'HudlStatsbomb',
            mobile: 'HudlStatsbombMobile',
            ott: undefined
        }
    },
    'iq-live': {
        namespace: {
            web: 'hudl_iq_live_web',
            mobile: 'hudl_iq_live_mobile',
            ott: undefined
        },
        appID: {
            web: 'HudlIQLive',
            mobile: 'HudlIQLiveMobile',
            ott: undefined
        }
    }
};

//# sourceMappingURL=HudlTrackers.js.map